<div class="title-skeleton loading-background" [ngClass]="size"></div>
